<script lang="ts" setup>
import { inject, computed } from 'vue';
import { CONTEXT_KEY } from './types';

defineOptions({
  name: 'CarouselItem',
});

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
});

const context = inject(CONTEXT_KEY);

if (!context) {
  console.error('Carousel.Item 必须在 Carousel.Root 组件内部使用');
}

const isInView = computed(() => {
  const currentPage = context?.currentPage.value ?? 0;
  const slidesPerPage = context?.slidesPerPage.value ?? 1;

  return props.index >= currentPage && props.index < (currentPage + slidesPerPage);
});
</script>

<template>
  <div
    class="embla__slide embla__item"
    data-scope="carousel"
    data-part="item"
    role="group"
    aria-roledescription="slide"
    :data-index="props.index"
    :data-inview="isInView ? '' : undefined"
    :inert="isInView ? undefined : true"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.embla__slide {
  flex: 0 0 calc(var(--slide-item-size));
  min-width: 0;
  padding-left: var(--slide-spacing);
}
</style>
